import { Action, createAction, createReducer, on, props } from '@ngrx/store';

export const setVerifyMode = createAction('[Verify Mode Set verifyMode Info', props<{ verifyMode: boolean }>());

export function VerifyModeReducer(pState: boolean | undefined, action: Action) {
  return createReducer(
    {},
    on(setVerifyMode, (state, _verify) => _verify.verifyMode)
  )(pState, action);
}
